export enum TaskAssignedFrom {
    AssignFromMarkerPopup = "assignFromMarkerPopup",
    AssignFromSearch = "search",
    AssignFromTerminalRun = "terminalRun"
  }